export default __webpack_public_path__ + "static/media/iphone_03.b2eb2251.png";